export const EXTENSIVE_REPORTS_AGENDA_MOUNTED = "EXTENSIVE_REPORTS_AGENDA_MOUNTED"
export const extensiveReportsAgendaMounted = () => ({
    type: EXTENSIVE_REPORTS_AGENDA_MOUNTED,
})

export const CLEAR_EXTENSIVE_REPORTS_DATA = "CLEAR_EXTENSIVE_REPORTS_DATA"
export const clearExtensiveReportsData = () => ({
    type: CLEAR_EXTENSIVE_REPORTS_DATA,
})
